import { store } from 'app/shared/store/store';
import { configService } from 'app/shared/services/config/config.service';
import { FeatureStatus } from 'app/shared/models/feature-status.model';
import { FeatureKey } from 'app/shared/models/feature-key';

class FeatureApiService {
  private apiBaseURL: string;
  private apimSubscriptionKey: string;

  private getConfig() {
    if (!this.apiBaseURL && !this.apimSubscriptionKey) {
      const configData = store.get('configData');
      this.apiBaseURL = configData.bffApiUrl;
      this.apimSubscriptionKey = configData.bffOcpApimSubscriptionKey;
    }
  }

  public getFeatureFlagStatus = async (featureKeys: FeatureKey[]): Promise<FeatureStatus> => {
    if (featureKeys === null || featureKeys.length === 0) {
      throw 'Invalid Argument featureKeys';
    }

    this.getConfig();
    const httpHeaders = configService.getHttpHeaders();
    httpHeaders['Ocp-Apim-Subscription-Key'] = this.apimSubscriptionKey;

    const keys = featureKeys.join(',');
    const requestUrl = `${this.apiBaseURL}/feature?keys=${keys}`;

    return await fetch(requestUrl, {
      method: 'GET',
      headers: httpHeaders
    })
      .then((response) => {
        if (!response.ok) {
          // if error occurs, then feature is disabled by default
          return null;
        }
        return response.json();
      })
      .then((data) => {
        const featureStatus = {};
        for (const [key, value] of Object.entries(data)) {
          featureStatus[key as FeatureKey] = value as boolean;
        }

        return featureStatus;
      })
      .catch(() => {
        // if error occurs, then feature is disabled by default
        return null;
      });
  };
}

export const featureApiService = new FeatureApiService();
